import React from 'react'
import {Button, Popup, PopupProps} from 'semantic-ui-react'
import './style.css'

export interface ISettingsPopupProps extends Omit<PopupProps, 'children'> {
  content?: React.ReactNode
}

export function SettingsPopup(props: ISettingsPopupProps) {
  const {content, ...rest} = props

  return (
    <Popup
      // inverted
      className='settings-popup'
      openOnTriggerMouseEnter={false}
      closeOnTriggerMouseLeave={false}
      size='tiny'
      position='bottom left'
      trigger={
        <Button
          compact
          size='tiny'
          icon='settings'
        />
      }
      content={<div className='content'>{content}</div>}
      {...rest}
    />
  )
}
